<slider side="left">

    <div body>
        <a class="slider-menu-logo" [routerLink]="rootPage?.link">
            <img src="assets/images/logo.svg" alt="">
          </a>
        <pages-menu *ngIf="rootPages" [root]="rootPages" class="top-menu"></pages-menu>
        <div class="btn-menu btn-menu-first">
            <a href="">
                МТК 523
              </a>
              <a href="">
                Портал ТК 023
              </a>
        </div>
        <div class="btn-menu">
            <a class="slider-menu-search">
                <ico ico="search_24" [size]="24"></ico>
              </a>
            <div class="slider-menu-locale">
                <locale></locale>
                {{rootPage.name}}                
            </div>
        </div>   
    </div>
    
</slider>